import { UserTypeValues } from 'shared-pages';

/* ---------------------------------------------------------------- */
/* Συστατικά \"types\" για το entity_params:                          */
/* ---------------------------------------------------------------- */

export const EntityTypeValues = {
  PlatformUsers: 'platformusers',
  Collectors: 'collectors',
  CollectionPoints: 'collectionpoints',
  WasteReceptionPoints: 'wastereceptionpoints',
  Contributors: 'contributors',
  Drivers: 'drivers',
} as const;

export type EntityType =
  | typeof EntityTypeValues.PlatformUsers
  | typeof EntityTypeValues.Collectors
  | typeof EntityTypeValues.CollectionPoints
  | typeof EntityTypeValues.WasteReceptionPoints
  | typeof EntityTypeValues.Contributors
  | typeof EntityTypeValues.Drivers;

/* Επιλογές για selects/filters */
export const ENTITY_TYPE_OPTIONS: { value: EntityType; label: string }[] = [
  { value: EntityTypeValues.PlatformUsers, label: 'Χρήστες Πλατφόρμας' },
  { value: EntityTypeValues.Collectors, label: 'Συλλέκτες' },
  { value: EntityTypeValues.CollectionPoints, label: 'Σημεία Συλλογής' },
  { value: EntityTypeValues.WasteReceptionPoints, label: 'Σημεία Παραλαβής Απορριμάτων' },
  { value: EntityTypeValues.Contributors, label: 'Υπόχρεοι Εισφορών' },
  { value: EntityTypeValues.Drivers, label: 'Οδηγοί Συλλεκτών' },
];

export const ENTITY_TYPE_LABEL: Record<string, string> = ENTITY_TYPE_OPTIONS.reduce(
  (acc, opt) => ({ ...acc, [opt.value]: opt.label }),
  {} as Record<string, string>,
);

/* ---------------------------------------------------------------- */
/* Mapping userTypeId -> entityType                                  */
/* (επιστρέφει undefined αν ο τύπος δεν υποστηρίζεται από το system) */
/* ---------------------------------------------------------------- */
export function userTypeIdToEntityType(
  userTypeId: number | undefined | null,
): EntityType | undefined {
  switch (userTypeId) {
    case UserTypeValues.PlatformOwner:
      return EntityTypeValues.PlatformUsers;
    case UserTypeValues.Collector:
      return EntityTypeValues.Collectors;
    case UserTypeValues.CollectionPoint:
      return EntityTypeValues.CollectionPoints;
    case UserTypeValues.WasteReceptionPoint:
      return EntityTypeValues.WasteReceptionPoints;
    case UserTypeValues.Contributor:
      return EntityTypeValues.Contributors;
    case UserTypeValues.CollectorDriver:
      return EntityTypeValues.Drivers;
    default:
      return undefined;
  }
}
